import { useAsyncData } from '@/hooks/useAsyncData';
import type { ClientTestGroups } from '@/api/clients';

/**
 * Список групп для фильтра — независимый запрос (не из текущей отфильтрованной
 * выборки строк), см. докблок CustomerController::testGroups() в Laravel:
 * иначе для "Цены → Тесты" (только подключённые) фильтр то есть, то пропадает
 * в зависимости от того, у скольких из УЖЕ подключённых тестов есть группа.
 * Параметризован фетчером — карточка клиента запрашивает группы по account id
 * (fetchClientTestGroups), мастер создания — по общему каталогу
 * (fetchTestCatalogGroups), сама логика загрузки/отмены одинаковая.
 */
export function useGroupOptions(fetcher: () => Promise<ClientTestGroups>, deps: unknown[]) {
  // Ошибка не показывается: без групп фильтр просто пустой, список работает.
  const { data } = useAsyncData(fetcher, deps);

  return { groups: data?.groups ?? [], ungroupedValue: data?.ungroupedValue ?? null };
}
